import { useTranslation } from "react-i18next"
import './HowToRead.css'

function HowToRead() {
  const { t } = useTranslation()

  return (
    <div className="how-to-result">
      <div className="page">
        <h1 className="colorBlack">{t('result.content.title')}</h1>
        <div className="chapter__container">
          <section className="chapter">
            <h3 className="howTo">{t('result.content.chapter1.title')}</h3>
            <p>{t('result.content.chapter1.p1')}</p>
            <p>{t('result.content.chapter1.p2')}</p>
            <p>{t('result.content.chapter1.p3')}</p>
            <p>{t('result.content.chapter1.p4')}</p>
            <ul>
              <li>
                <h4>1 - {t('result.content.chapter1.li1.title')}</h4>
                <p>{t('result.content.chapter1.li1.content')}</p>
              </li>
              <li>
                <h4>2 - {t('result.content.chapter1.li2.title')}</h4>
                <p>{t('result.content.chapter1.li2.content')}</p>
              </li>
              <li>
                <h4>3 - {t('result.content.chapter1.li3.title')}</h4>
                <p>{t('result.content.chapter1.li3.content')}</p>
              </li>
              <li>
                <h4>4 - {t('result.content.chapter1.li4.title')}</h4>
                <p>{t('result.content.chapter1.li4.content')}</p>
                <p>{t('result.content.chapter1.p5')}</p>
              </li>
            </ul>
          </section>
        </div>
      </div>

      <div className="">
        <div className="">
          <section className="chapter">
            <div className="axis-cards">
              <div className="axis-rail" aria-hidden="true"></div>

              <div className="axis-card">
                <div className="axis-title">1. {t('result.content.chapter1.table.row1.title')}</div>
                <div className="axis-items">
                  <p>{t('result.content.chapter1.table.row1.c1')}</p>
                  <p>{t('result.content.chapter1.table.row1.c2')}</p>
                  <p>{t('result.content.chapter1.table.row1.c3')}</p>
                  <p>{t('result.content.chapter1.table.row1.c4')}</p>
                  <p>{t('result.content.chapter1.table.row1.c5')}</p>
                  <p>{t('result.content.chapter1.table.row1.c6')}</p>
                  <p>{t('result.content.chapter1.table.row1.c7')}</p>
                  <p>{t('result.content.chapter1.table.row1.c8')}</p>
                </div>
              </div>

              <div className="axis-card">
                <div className="axis-title">2. {t('result.content.chapter1.table.row2.title')}</div>
                <div className="axis-items">
                  <p>{t('result.content.chapter1.table.row2.c1')}</p>
                  <p>{t('result.content.chapter1.table.row2.c2')}</p>
                  <p>{t('result.content.chapter1.table.row2.c3')}</p>
                  <p>{t('result.content.chapter1.table.row2.c4')}</p>
                  <p>{t('result.content.chapter1.table.row2.c5')}</p>
                  <p>{t('result.content.chapter1.table.row2.c6')}</p>
                </div>
              </div>

              <div className="axis-card">
                <div className="axis-title">3. {t('result.content.chapter1.table.row3.title')}</div>
                <div className="axis-items">
                  <p>{t('result.content.chapter1.table.row3.c1')}</p>
                  <p>{t('result.content.chapter1.table.row3.c2')}</p>
                  <p>{t('result.content.chapter1.table.row3.c3')}</p>
                  <p>{t('result.content.chapter1.table.row3.c4')}</p>
                  <p>{t('result.content.chapter1.table.row3.c5')}</p>
                  <p>{t('result.content.chapter1.table.row3.c6')}</p>
                  <p>{t('result.content.chapter1.table.row3.c7')}</p>
                </div>
              </div>

              <div className="axis-card">
                <div className="axis-title">4. {t('result.content.chapter1.table.row4.title')}</div>
                <div className="axis-items">
                  <p>{t('result.content.chapter1.table.row4.c1')}</p>
                  <p>{t('result.content.chapter1.table.row4.c2')}</p>
                  <p>{t('result.content.chapter1.table.row4.c3')}</p>
                  <p>{t('result.content.chapter1.table.row4.c4')}</p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      <div className="page no-break">
        <div className="chapter__container">
          <section className="chapter">
            <h3>{t('result.content.chapter2.title')}</h3>
            <p>{t('result.content.chapter2.p1')}</p>
            <p>{t('result.content.chapter2.p2')}</p>
            <p>{t('result.content.chapter2.p3')}</p>
            <p>{t('result.content.chapter2.p4')}</p>

            <h3 className="chapter3-title">{t('result.content.chapter3.title')}</h3>
            <p>{t('result.content.chapter3.p1')}</p>
            <p>{t('result.content.chapter3.p2')}</p>

            <h3>{t('report.axis-legend.title')}</h3>
            <div className="axis-legend-columns">
              <div className="axis-legend-image">
                <img src="/gommettesPdf.png" alt="Axes DigiScore" />
              </div>
              <div className="axis-legend-text">
                <p><strong>Les 4 axes du Digiscore sont présents dans la colonne de gauche. La pastille en rouge ou vert apporte une information complémentaire.</strong></p>
                <p>{t('report.axis-legend.p6')}</p>
                <p>{t('report.axis-legend.p7')}</p>
                <p>{t('report.axis-legend.p8')}</p>
                <p>{t('report.axis-legend.p9')}</p>
                <p>{t('report.axis-legend.p10')}</p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  )
}

export default HowToRead